import React from 'react';
import PropTypes from 'prop-types';
import UserItem from './UserItem';
import OrderProp from '../../../shop/propTypes/orderProp';
import translate from '../../../../commonComponents/translate';

function UsersContainer(props) {
  const { t, opportunity } = props;
  const { owner, operator } = opportunity;
  return (
    <div className="users-container">
      <UserItem
        user={owner}
        title={t('shop.client')}
        wrapperClass="green-user"
      />
      {operator ? (
        <UserItem
          user={operator}
          title={t('order_operator')}
          wrapperClass="blue-user"
          showPhone
        />
      ) : null}
    </div>
  );
}

UsersContainer.propTypes = {
  t: PropTypes.func.isRequired,
  opportunity: PropTypes.shape(OrderProp.propType).isRequired,
};

export default translate(UsersContainer);
